import { Drawer as AntdDrawer, DrawerProps as AntdDrawerProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import { cx } from "antd-style";

export interface DrawerProps extends AntdDrawerProps {}

export const drawerPrefixCls = `${CMP_PREFIX}-drawer`;

export const Drawer = ({
  title,
  className,
  maskClosable = false,
  ...props
}: DrawerProps) => {
  return (
    <AntdDrawer
      title={title}
      maskClosable={maskClosable}
      className={cx(className, {
        [`${drawerPrefixCls}-has-no-title`]: !title,
      })}
      {...props}
    />
  );
};
